<side-menu-svg-sprite></side-menu-svg-sprite>
<div [class.overlay]="isAdminMobile" (click)="toggleCommunityMobileMenu($event)"></div>
<div class="slected-menulist" (click)="toggleCommunityMobileMenu($event)">
    <span class="menu-title">{{ "community.sideMenu.menu" | translate }}</span>
    <svg>
        <use xlink:href="#listMenuIcon"></use>
    </svg>
</div>
<div class="community-side-menu" [class.showMobileMenu]="isAdminMobile">
    <div class="close-menu" (click)="toggleCommunityMobileMenu($event)">
        <svg>
            <use xlink:href="#closeIcon"></use>
        </svg>
    </div>
    <div class="side-menu-list">
        <h6 class="menu-label">{{ "community.sideMenu.community" | translate }}</h6>
        <ul>
            <li class="side-menu-item" routerLink="/community/home" routerLinkActive="active">
                <div class="item-left">
                    <div class="item-icon">
                        <svg>
                            <use xlink:href="#communityHomeIcon"></use>
                        </svg>
                    </div>
                    <span class="item-label">
                      {{ "community.sideMenu.home" | translate }}
                    </span>
                </div>
                <div class="item-right">
<!--                    <span class="count" [ngStyle]="{'background-color': lightPrimaryColor}">24</span>-->
                </div>
            </li>
            <li *ngIf="isLoggedIn" class="side-menu-item" routerLink="/community/members" routerLinkActive="active">
                <div class="item-left">
                    <div class="item-icon">
                        <svg>
                            <use xlink:href="#communityMemberIcon"></use>
                        </svg>
                    </div>
                    <span class="item-label">
                      {{ "community.sideMenu.members" | translate }}
                    </span>
                </div>
                <!-- <div class="item-right">
                    <span class="count">24</span>
                </div> -->
            </li>
            <li *ngIf="isLoggedIn && isAdmin" class="side-menu-item" routerLink="/community/settings" routerLinkActive="active">
                <div class="item-left">
                    <div class="item-icon">
                        <svg>
                            <use xlink:href="#communitySettingIcon"></use>
                        </svg>
                    </div>
                    <span class="item-label">
                        Settings
                    </span>
                </div>
                <!-- <div class="item-right">
                    <span class="count">24</span>
                </div> -->
            </li>
            <li *ngIf="isLoggedIn" class="side-menu-item" routerLink="/community/my-profile" routerLinkActive="active">
              <div class="item-left">
                  <div class="item-icon">
                      <svg>
                          <use xlink:href="#communityMyProfileIcon"></use>
                      </svg>
                  </div>
                  <span class="item-label">
                    {{ "community.sideMenu.myProfile" | translate }}
                  </span>
              </div>
          </li>
        </ul>
    </div>

    <div class="side-menu-list">

        @if(rooms?.length || isAdmin) {
          <h6 class="menu-label">{{ "community.sideMenu.rooms" | translate }}</h6>
        }

        <ul>
            <li *ngIf="isLoggedIn && isAdmin" class="side-menu-item" routerLink="/community/manage-rooms" routerLinkActive="active">
                <div class="item-left">
                    <div class="item-icon">
                        <svg>
                            <use xlink:href="#communitySettingOneIcon"></use>
                        </svg>
                    </div>
                    <span class="item-label">
                        Manage Rooms
                    </span>
                </div>
                <div class="item-right">
                    <span class="count" [ngStyle]="{'background-color': lightPrimaryColor}">{{totalRooms}}</span>
                </div>
            </li>
            <ng-container *ngFor="let room of rooms">
                <li class="side-menu-item" [routerLink]="'/community/rooms/' + room?.id" routerLinkActive="active">
                    <div class="item-left">
                        <div class="item-icon">
                            <svg>
                                <use [attr.xlink:href]="'#' + room.roomIcon"></use>
                            </svg>
                        </div>
                        <span class="item-label">
                            {{room.name}}
                        </span>
                    </div>
                    <!-- <div class="item-right">
                        <span class="count">24</span>
                    </div> -->
                </li>
            </ng-container>
        </ul>
    </div>
</div>
